// Canonical dynamic-import factory for `@atlassian/conversation-assistant-auto-suggest`. Shared by the live
// `lazy()` boundary and intent-time preload to keep chunk identity single-sourced.
export type AutoSuggestModule = typeof import('./index');

export function importAutoSuggest(): Promise<AutoSuggestModule> {
	return import(
		/* webpackChunkName: "@atlassian/conversation-assistant-chat-prompt-input/conversation-assistant-auto-suggest" */
		'./index'
	);
}
